import * as Actions from 'store/actions/app/series_entry.actions'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_enabled_series_entry: false,
  enabled_series_entry: [],

  enabling_series_entry: false,

  finishing_series_entry_ids: [],
  finished_series_entry_ids: [],
}

const seriesEntryReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ENABLED_SERIES_ENTRY: {
      return {
        ...state,
        loading_enabled_series_entry: action.payload.loading ?? state.loading_enabled_series_entry,
        enabled_series_entry: action.payload.data ?? state.enabled_series_entry,
      }
    }
    case Actions.ENABLING_SERIES_ENTRY: {
      return {
        ...state,
        enabling_series_entry: action.payload.enabling ?? state.enabling_series_entry,
      }
    }
    case Actions.FINISH_SERIES_ENTRY: {
      return {
        ...state,
        finishing_series_entry_ids: toggleIdInArray(state.finishing_series_entry_ids, action.payload.finishing_id),
        finished_series_entry_ids: toggleIdInArray(state.finished_series_entry_ids, action.payload.finished_id),
        enabled_series_entry: state.enabled_series_entry.filter(item => item.ingreso_serie_id !== action.payload.finished_id)
      }
    }
    default: {
      return state
    }
  }
}

export default seriesEntryReducer